import * as yup from "yup";
import { DEFAULT_MESSAGES } from "../defaultMessages";

export const createTipoEspacioSchema = yup.object({
  nombre: yup.string().required(DEFAULT_MESSAGES.REQUIRED),

  con_sub_tipo: yup.boolean().required(DEFAULT_MESSAGES.REQUIRED),
  // Consultar a ari por el requerimiento del espacio sub-tipo
});
